import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectedAddress, duplexAddress } from '../../../selectors/ServiceAddress';
//Components
import AddressInfo from '../../Sections/SubmitRequest/AddressInfo';
import FortisButton from '../../Basic/FortisButton';
import UsefulLinks from './UsefulLinks';
import ScheduleDate from './ScheduleDate';
import ServicesLink from './ServicesLink';
import util from '../../../lib/util';

class ConfirmationPage extends React.Component {
    printRequest = () => {
        window.print();
        return false;
    };
    
    render() {
        const p = this.props;
        const confirmationLookup = window.osa.lookup.confirmation;
         const cl =  window.osa && window.osa.commonLookup && window.osa.commonLookup;
       // const siteUrl = window.osa.siteUrl;
        const trackRequestLink = "<a href='/dashboard'>track your service requests online</a>.";
        const gettingStartedLink = " <a href='/dashboard'>Get started here</a>.";
        const projectNumberMsg = p.projectNo ?
            (<b>Your project number is: {p.projectNo}<br /></b>) : null;
        let emailConfirmationMsg = null;
        if (p.projectNo) //
        {
            if (p.hasUserLoggedIn)
                emailConfirmationMsg = (
                    <p>
                        <span dangerouslySetInnerHTML={{ __html: confirmationLookup.emailConfirmation }} />
                        <br />
                    </p>
                );
            else
                emailConfirmationMsg = (
                    <p>
                        <span dangerouslySetInnerHTML={{ __html: confirmationLookup.emailConfirmation + ' ' + confirmationLookup.loginToYourProfile + ' ' + trackRequestLink }} />
                        <br />
                    </p>
                );
        }
        const signUpForOnlineProfileMsg = p.hasUserLoggedIn ? null :
            (<p><span dangerouslySetInnerHTML={{ __html: confirmationLookup.signUpForOnlineProfile + gettingStartedLink }} /><br /></p>);
        util.trackGoogleAnalytics(p.pageName, 'Steps', 'Confirmation');
        util.trackGoogleAnalytics(p.pageName, 'Project Submitted', p.offRampMessage ? 'Project Submitted with offramp' : 'Project Submitted without offramp');
        return (
            <div className="row">
                <div className="col-sm-9" id="printArea">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4 className="text-primary">Thank you!</h4>
                            <p>
                                <b>
                                    {confirmationLookup.title}
                                </b>
                            </p>
                            <AddressInfo address={p.address} />
                            {p.isTwoMeter ? <AddressInfo address={p.address2} /> : null}
                            <p>
                                {projectNumberMsg}
                                <br />
                                <span dangerouslySetInnerHTML={{ __html: p.offRampMessage }} />
                            </p>
                            {emailConfirmationMsg}
                            {signUpForOnlineProfileMsg}
                            <div className="row form-group no-print">
                                <div className="col-sm-12">
                                    <FortisButton text="Print confirmation" onClick={this.printRequest} />
                                </div>
                            </div>
                            {(p.offRampMessage) ? null :
                                <ScheduleDate selectedSchedule={p.selectedSchedule} lookup={confirmationLookup.scheduleDate} />
                            }
                        </div>
                    </div>
                    <UsefulLinks lookup={confirmationLookup} pageName={p.pageName} isCrteditHistoryRequired={p.isCreditCheckRequired} offRamp={p.offRampMessage} />
                </div>
                <div className="col-sm-3 no-print" >
                    <ServicesLink  lookup={cl && cl.services} />
                </div>
            </div>
        );
    }
}
ConfirmationPage.propTypes = {
    projectNo: PropTypes.string,
};
const mapStateToProps = (state) => {
    return {
        address: selectedAddress(state),
        address2: duplexAddress(state),
        isTwoMeter: state.form.buildingType == "2" && state.form.duplexMeterCount == "2",
        projectNo: state.gas.project && state.gas.project.data && state.gas.project.data.projectNo,
        offRampMessage: state.gas.submittedProject && state.gas.submittedProject.message,
        selectedSchedule: state.gas.schedule && state.gas.schedule.dateSelected,
        hasUserLoggedIn: state.gas.user && state.gas.user.isAuthenticated,
        pageName: state.gas.pageName,
        isCreditCheckRequired: state.gas.submittedProject && state.gas.submittedProject.isCreditCheckRequired,
    };
};
export default connect(mapStateToProps)(ConfirmationPage);